import {
  Box,
  Flex,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import {
  FaEnvelope,
  FaFacebook,
  FaLocationArrow,
  FaPhone,
  FaWhatsapp,
} from "react-icons/fa";

const ContactPanel = () => {
  return (
    <>
      <Heading size="md" my={2}>
        Get in touch
      </Heading>
      <Text fontSize={{ base: "xs", md: "sm" }} color="gray.600" mb={4}>
        Looking for a quotation, advice, or have a question about our services?
        We’re here to help! Whether it's a small job or a larger project, we are
        happy to discuss your requirements and provide expert recommendations.
      </Text>

      <Stack
        direction={{ base: "column", md: "row" }}
        alignItems={"start"}
        mt={10}
        spacing={20}
      >
        {/* Contact Details */}
        <VStack align="start" spacing={5} height={"100%"} flex={1}>
          <Heading mb={0} size={"sm"}>
            Contact Details
          </Heading>
          <Flex align="center">
            <Icon as={FaEnvelope} boxSize={5} mr={2} />
            <Text
              as="a"
              href="mailto:sw@fixedandfitted.info"
              align="center"
              color="blue.600"
              fontSize="sm"
            >
              sw@fixedandfitted.info
            </Text>
          </Flex>
          <Flex
            as="a"
            href="https://wa.me/447845255246"
            target="_blank"
            rel="noopener noreferrer"
            align="center"
            spacing={1}
          >
            <Icon as={FaWhatsapp} boxSize={6} mr={1} />
            <Text color="blue.600" fontSize="sm">
              07845 255 246
            </Text>
          </Flex>
          <Flex
            as="a"
            href="https://www.facebook.com/share/1BJ8sp5aRq/"
            target="_blank"
            rel="noopener noreferrer"
            align="center"
          >
            <Icon as={FaFacebook} boxSize={5} />
            <Text fontSize="sm" ml={1} color="blue.600">
              Swfixed Andfitted
            </Text>
          </Flex>
        </VStack>

        <VStack align="start" spacing={5} height="100%" flex={1}>
          <Heading size="sm" mb={0}>
            Areas Served
          </Heading>

          <Text fontSize={{ base: "xs", md: "sm" }} color="gray.600">
            We are based in Cannock but are happy to consider all jobs within a
            reasonable distance. The quickest and easiest way to find out is to
            give us a call, and we'll be more than happy to assist.
          </Text>

          <Text fontSize={{ base: "xs", md: "sm" }} fontWeight="bold" mt={2}>
            Here are some of the areas we have recently worked:
          </Text>

          {/* Two-Column Layout for Areas */}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3} width="100%">
            {[
              "Cannock",
              "Hednesford",
              "Norton Canes",
              "Burntwood",
              "Heath Hayes",
              "Rugeley",
              "Brownhills",
              "Cheslyn Hay",
              "Chadsmoor",
              "... & more"

            ].map((area, index) => (
              <Box
                key={index}
                fontSize={{ base: "xs", md: "sm" }}
                color="gray.600"
              >
                ✅ {area}
              </Box>
            ))}
          </SimpleGrid>
        </VStack>

        <VStack
          align="start"
          spacing={10}
          height={"100%"}
          flex={2}
          display={{ base: "none", md: "flex" }}
        >
          <Heading mb={-4} size={"sm"}>
            Local Map
          </Heading>
          <Box
            as="iframe"
            src={`https://www.google.com/maps/embed/v1/view?center=52.6907,-2.0305&zoom=12&key=AIzaSyCrx_Ifbpidv0lYB-vk-_EY5rbhBb_OJ1E&maptype=roadmap`}
            height="300px"
            w={"100%"}
            borderRadius="md"
            border="0"
            allowFullScreen=""
            loading="lazy"
            title="Google Map"
            mb={6}
          />
        </VStack>
      </Stack>
    </>
  );
};

export default ContactPanel;
